import { phoneHref } from "@/lib/data";

export default function StickyBar({ content }) {
  const phone = content?.phone || "07378114330";
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#070b12]/95 border-t border-[#1e9bff]/30 p-3 flex gap-3 backdrop-blur-lg" data-testid="sticky-mobile-bar">
      <a
        href={phoneHref(phone)}
        data-testid="sticky-call-btn"
        className="flex-1 py-3 rounded-xl border border-[#1e9bff]/40 bg-[#1e9bff]/10 text-[#1e9bff] font-mono-lbl text-xs font-bold uppercase tracking-wider text-center"
      >
        Call Now
      </a>
      <a
        href="/#booking"
        data-testid="sticky-book-btn"
        className="flex-1 py-3 rounded-xl bg-[#1e9bff] text-black font-mono-lbl text-xs font-bold uppercase tracking-wider text-center flex items-center justify-center"
      >
        Book Now
      </a>
    </div>
  );
}
